import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=b72d61ce&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=b72d61ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d61ce",
  null
  
)

export default component.exports